/* eslint-disable camelcase */
import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
// import { getQueryVal, getUrlParams, getUrlQueryObj } from '@/assets/js/utils'
import { getQueryVal, getUrlParams } from '@/assets/js/utils'
import { finderEvtCollect } from '@/assets/js/finder'
import { GetUserToken, CheckUserInfoBind } from '@/query/api'
import getEnv from '../utils/getEnv'
import { getSStorage, setSStorage } from '../utils'
import { isThirdPartySource } from '../utils/thirdParty'

Vue.use(Router)
let basePath = ''
if (process.env.NODE_ENV === 'production') {
  basePath = '/activityRefactoring/'
} else {
  basePath = '/activityRefactoring/'
}

// 验证localStorage中的token有效性并处理路由导航
function validateStoredTokenAndRoute (storedToken, to, next) {
  console.warn(storedToken, 'validateStoredTokenAndRoute')
  CheckUserInfoBind({
    token: storedToken,
    appVer: '4.0.1',
    version: '4.0.1',
    channelId: '60001',
    deviceId: 'e2d76f3b-c4a2-42ed-a482-0a5bf767dbf1',
    platType: getSStorage('platType') || 5,
    'At-Platform-Type': 5
  }).then(data => {
    if (data.retcode === 0) {
      localStorage.setItem('interfaceToken', storedToken)
      console.warn('CheckUserInfoBind: success')
      next()
    } else {
      console.error('CheckUserInfoBind error:', data.retcode)
      /**
       * 如果这里CheckUserInfoBind校验token失败 删除token
       * home.vue中window.wx.miniProgram.navigateTo()中打开webview获取(失效的token)并且在url拼接重复进入这里 死循环
       *
       * 若CheckUserInfoBind 校验一个有效的token不会陷入死循环
       * 若CheckUserInfoBind 校验一个失效的token会陷入死循环
       */

      localStorage.removeItem('interfaceToken')
      next() // 此时localStorage中没有token home.vue 会在home.vue中window.wx.miniProgram.navigateTo()
    }
  }).catch((error) => {
    console.error('CheckUserInfoBind catch:', error)
    localStorage.removeItem('interfaceToken')
    next()
  })
}

const router = new Router({
  mode: 'history',
  // mode: 'hash',
  base: basePath,
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home/:id',
      name: 'home',
      component: home
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  let activitySource = to.query.activitySource || ''
  localStorage.setItem('firstEnterTime', new Date().getTime())
  localStorage.setItem('activitySource', activitySource)
  let getTicketTime = localStorage.getItem('getTicketTime') // 上次成功获取优惠券的时间

  const utm_source = getQueryVal('utm_source')
  if (utm_source) {
    finderEvtCollect('config', {
      utm_source
    })
  }

  console.log('-------to------', to)
  const { platType } = await getEnv()
  const isThirdParty = isThirdPartySource(to.query)
  setSStorage('platType', isThirdParty ? 5 : platType)

  // 三方渠道统一按浏览器 H5 领取，不消费 URL 或本地的 App/小程序登录态。
  if (isThirdParty) {
    next()
    return
  }

  const params = getUrlParams(to.fullPath)
  // url中可能会携带ticket(兑吧) | token()
  const { ticket, token } = params
  const interfaceTicket = localStorage.getItem('interfaceTicket')
  console.warn(ticket, interfaceTicket, 'url:ticket, interfaceTicket')
  if (ticket && interfaceTicket !== ticket) {
    GetUserToken({ ticket }).then(({data}) => {
      if (data.result.token) {
        localStorage.setItem('interfaceToken', data.result.token)
        localStorage.setItem('interfaceTicket', ticket)
        next()
      } else {
        console.warn('GetUserToken error')
        next()
      }
    }, () => {
      console.warn('GetUserToken error1')
      next()
    })
  } else if (token) {
    console.warn('url中携带了token')
    validateStoredTokenAndRoute(token, to, next)
  } else {
    console.warn('url中无token, 无ticket')
    // 领取时间过去7天或者领取时间不存在重置所有本地缓存
    if (!getTicketTime || (getTicketTime && (Date.now() - getTicketTime) > (10000))) {
      if (window.Prius && window.Prius.isInsideApp) {
        window.localStorage.clear()
        window.localStorage.setItem('version', '2.6.0')
      }
    }
    if (localStorage.getItem('interfaceToken')) {
      console.warn('从localStorage取出token')
      validateStoredTokenAndRoute(localStorage.getItem('interfaceToken'), to, next)
    } else {
      console.warn('url中无ticket,token,localStorage无token')
      next()
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js